module.exports = __webpack_public_path__ + "img/mbeans.c2f28cb2.svg";